module.exports = __webpack_public_path__ + "static/media/21ECLAC21.5ffd220c.jpg";